export enum DistrictSortType {
    Id,
    Name,
    ProvinceName,
    CountryName,
    IsDeleted
}
